import { InjectionToken } from '@angular/core';

export const RXAP_TABLE_DATA_SOURCE_PAGINATOR = new InjectionToken('rxap/data-source/table/paginator');
export const RXAP_TABLE_DATA_SOURCE_SORT = new InjectionToken('rxap/data-source/table/sort');
export const RXAP_TABLE_DATA_SOURCE_FILTER = new InjectionToken('rxap/data-source/table/filter');
export const RXAP_TABLE_DATA_SOURCE_PARAMETERS = new InjectionToken('rxap/data-source/table/parameters');
export const RXAP_TABLE_DATA_SOURCE = new InjectionToken('rxap/data-source/table/source');
export const RXAP_TABLE_METHOD = new InjectionToken(
  'rxap/data-source/table/table-method',
);
